import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { Guid, IApiLink, ITranslations } from "@/types"

export interface IGetProductHierarchyProductModelDto {
    id: Guid
    description: string
    descriptionTranslations: ITranslations
    isExtManufacturer: boolean
    articleCount: number
    links?: IApiLink[]
}

export default class ProductHierarchyProductModel {
    id: Guid
    description: string
    descriptionTranslations: ITranslations
    isExtManufacturer: boolean
    articleCount: number

    linkGetProductModelArticles?: IApiLink

    constructor(dto: IGetProductHierarchyProductModelDto) {
        this.id = dto.id
        this.description = dto.description
        this.descriptionTranslations = dto.descriptionTranslations
        this.isExtManufacturer = dto.isExtManufacturer
        this.articleCount = dto.articleCount

        this.linkGetProductModelArticles = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.articleDescription && lnk.rel === ApiLinkRel.all)
    }

    get hasArticles(): boolean {
        return this.articleCount > 0
    }
}
